import { render } from "./CompletedComponent.vue?vue&type=template&id=6024fcf7&scoped=true"
import script from "./CompletedComponent.vue?vue&type=script&lang=js"
export * from "./CompletedComponent.vue?vue&type=script&lang=js"

import "./CompletedComponent.vue?vue&type=style&index=0&id=6024fcf7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6024fcf7"]])

export default __exports__